import {TranslatePipe} from "@ngx-translate/core";
import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'sf-users-review-grid',
  templateUrl: './users-review-grid.component.html',
  styleUrl: './users-review-grid.component.scss',
  imports: [
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UsersReviewGridComponent {
    protected readonly reviews = [
      {
        desc: 'Thanks to SelfCV, I now have a professional and polished resume that I\'m confident in sending to potential employers. I will definitely be recommending your service to other job seekers. Keep up the great work!',
        user: 'Boris A.',
        avatar: 'B',
        profession: 'Software Engineer'
      },
      {
        desc: 'SelfCV offers an intuitive interface that makes creating a professional CV straightforward. Whether you\'re a student, a fresh graduate, or an experienced professional, the step-by-step process ensures that users of all levels can craft an impressive CV.',
        user: 'Mariam K.',
        avatar: 'M',
        profession: 'Backend Engineer'
      },
      {
        desc: 'Easy to use resume builder. They have very intuitive ui for customizing and keeping multiple versions of resume.',
        user: 'Konstantin B.',
        avatar: 'K',
        profession: 'Graphic Designer'
      },
      {
        desc: 'The right tool for creating CVs. As a student I was looking for a tool that could help me quickly create a CV for internship applications. This was just the right tool. I am very satisfied!',
        user: 'Garegin H.',
        avatar: 'G',
        profession: 'Frontend Engineer'
      },
      {
        desc: 'This is one of the best tools I’ve ever used - I was able to build my CV in seconds with high quality template. Highly recommended!',
        user: 'Elen M.',
        avatar: 'E',
        profession: 'Delivery Manager'
      },
      {
        desc: 'Amazing app with easy user experience. Loved it. Its intuitive and easy to navigate, designs are very nice.',
        user: 'Inesa T.',
        avatar: 'I',
        profession: 'Software Engineer'
      },
    ];
}
